// CEFR range on a fixed scale: filled rungs are the levels a lesson suits.
import { CEFR } from "../../shared/catalog";

export function LevelLadder({ range, mixed }: { range: [number, number]; mixed?: boolean }) {
  return (
    <span className={`ladder${mixed ? " ladder-mixed" : ""}`} aria-label={mixed ? "Any level" : `Level ${CEFR[range[0]]} to ${CEFR[range[1]]}`}>
      {CEFR.slice(1).map((lv, idx) => {
        const i = idx + 1;
        const on = mixed || (i >= range[0] && i <= range[1]);
        return <span key={lv} className={`rung${on ? " on" : ""}`} title={lv} />;
      })}
    </span>
  );
}
